import { FC, useEffect, useMemo, useState, useCallback } from "react"
import Img from "@/components/img"
import useConfBase from "@/hooks/useConfBase"
import styles from "@/components/styles/relateList.module.css"
import useAxios from "@/hooks/useAxios"
import u, { ELocalKey } from "@/util"

const RelateList: FC = () => {
    const [config, updateConfBase,getData] = useConfBase();
    const [list, setList] = useState<any[]>([])
    const { req } = useAxios("index/statistics", 'post', true);
    
    useEffect(() => {
        async function initData() {
            // Only fetch if not already in localStorage
            let qx = localStorage.getItem("__QX");

            // Check that qx is not null/empty/undefined string
            if (!qx || qx === "undefined") {
                await u.fetchQX(); // make sure fetchQX stores valid JSON
                qx = localStorage.getItem("__QX");
            }

            if (qx && qx !== "undefined") {
                try {
                    const res = JSON.parse(qx);
                    let data = res?.["maomiqixia"];

                    // If it's stringified, parse it
                    if (typeof data === "string") {
                        try {
                            data = JSON.parse(data);
                        } catch (e) {
                            console.error("Failed to parse maomiqixia:", e);
                            data = [];
                        }
                    }

                    // Only set list if it's an array
                    if (Array.isArray(data)) {
                        setList(data);
                    } else {
                        console.warn("maomiqixia is not an array:", data);
                    }
                } catch (err) {
                    console.error("Failed to parse __QX:", err);
                }
            } else {
                console.warn("__QX not set or invalid:", qx);
            }
        }

        initData();
    }, [config]);


    const hideOnNews = useMemo(() => {
        return window.location.href.indexOf("news") >= 0
    }, [])

    const clickStats = useCallback( async (x: any) => {
        req(u.getStatsParams(true, "youqingtujian", x?.name, window.location.pathname, false, true))
        return u.open(x.url)
    }, [])

    return (
        <div>
            {
                !hideOnNews && <>
                    <div className="s_h">友情推荐</div>
                    <div className={styles.r_l}>
                        {list.map((x: any, i: number) => {
                            return <div key={i} onClick={() => clickStats(x)}>
                                <Img src={x.local_img} encryptUrl={x.local_img} height={50} width={50} withoutSize/>
                                {x.name}
                            </div>
                        })}
                    </div>
                </>
            }
        </div>
    )
}
export default RelateList